import React from "react";
import ReadMore from "../../common/ReadMore";
import GalleryModal from "./components/Gallery.modal";
import TitleModal from "./components/Title.modal";

const InfoBodyMobile = ({ data }) => {

  return (
    <>
      <div
        className="col-12 h-lg-100 col-lg-6 m-auto mt-0"
        style={{ position: "relative" }}
      >
        <GalleryModal minImg={false} gallery={data.img} />
      </div>

      <div className="col-12 col-lg-6 ">
        <div style={{ height: "calc(100vh - 332px)", overflow: "auto" }}>
          <TitleModal title={data.titolo} />
          <div className="wrapText mt-lg-3">
            <ReadMore>{data.testo}</ReadMore>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfoBodyMobile;
